(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .controller('DropCModuleCtrl', DropCModuleCtrl);

  DropCModuleCtrl.$inject = ['$scope', 'dashboardResource', '$modalInstance', 'gettext', 'translationService'];

  function DropCModuleCtrl($scope, dashboardResource, $modalInstance, gettext, translationService) {
    var translate = translationService.sprintf;

    $scope.setup = {
      title: gettext('Confirm dropping course?'),
      message: translate(gettext('Dropping this course will delete all module progress and remove you from the course. <br><br> You cannot undo this action.')),
      buttons: [
        { label: gettext('Cancel'), cssClass: 'btn-info', result: 'dismiss' },
        { label: gettext('Drop'), cssClass: 'btn-primary', result: 'drop' }
      ]
    };
    $scope.modal = {
      content: 0,
      data: $scope.selectedCModule,
      status: '',
      confirmed: false
    };

    $scope.close = function(result) {
      if (result === 'drop')
        $scope.drop();
      else
        $modalInstance.dismiss(result);
    };

    $scope.drop = function() {
      $scope.modal.status = gettext('saving');

      dashboardResource.drop($scope.modal.data.id, function(result) {
          $scope.modal.confirmed = true;
          $modalInstance.close();
        },
        function(err) {
          $modalInstance.dismiss();
        });
    };
  }
})();
